import database from '../firebase/firebase';

export const adminTypes = {
    FETCH_DATA: "admin/GETTING_DATA",
    MANAGE_VACANCY: "admin/MANAGEVACANCY",
    DELETE_VACANCY: "admin/DELETE_VACANCY"
};

export const getVacancies = (vacancies) => ({
    type: adminTypes.FETCH_DATA,
    vacancies
})

export const manageVacancy = (newValues) => ({
    type: adminTypes.MANAGE_VACANCY,
    newValues
})

export const showVacanciesAdmin = () => {
    return (dispatch) => {
        return database.collection(`vacancies`)
        .get()
        .then((snapshot) => {
            let jobs = []
            snapshot.forEach((doc) => {
                jobs.push(doc.data())
            });
            dispatch(getVacancies(jobs))
        })
        .catch((err) => console.log(err))
    }
}